import {
    getPriceUnit,
    deletePriceUnit,
    createPriceUnit,
    updatePriceUnit
} from '../../../services/PriceUnitService';
import {
    CONFIRMED_GET_PRICE_UNIT
} from './PriceUnitTypes';

export function getPriceUnitAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'PRICE_UNIT_LOADING' });
            getPriceUnit(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetPriceUnitAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetPriceUnitAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetPriceUnitAction(data) {
    return {
        type: CONFIRMED_GET_PRICE_UNIT,
        payload: data,
    };
}

export function deletePriceUnitAction(id, history) {
    return (dispatch, getState) => {
        return deletePriceUnit(id).then((response) => {
            return response;
        });
    };
}

export function createPriceUnitAction(data) {
    return () => {
        return createPriceUnit(data).then((response) => {
            return response;
        });
    };
}

export function updatePriceUnitAction(id, data) {
    return () => {
        return updatePriceUnit(id, data).then((response) => {
            return response;
        });
    };
}

